import { render, staticRenderFns } from "./JSONField.vue?vue&type=template&id=ecdccd40&scoped=true&"
import script from "./JSONField.vue?vue&type=script&lang=ts&"
export * from "./JSONField.vue?vue&type=script&lang=ts&"
import style0 from "./JSONField.vue?vue&type=style&index=0&id=ecdccd40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdccd40",
  null
  
)

export default component.exports